export const lightBlue = {
  50: "#E0F7FA",
  100: "#AFE3F1",
  200: "#7ECFE8",
  300: "#4DBBDF",
  400: "#1CA7D6",
  500: "#1693BE",
  600: "#0F7EA6",
  700: "#0A7096",
  800: "#05536F",
  900: "#003547",
  A100: "#84FFFF",
  A200: "#18FFFF",
  A400: "#00E5FF",
  A700: "#00B8D4",
  A800: "#285D97"
}
export const blueGrey = {
  50: "#ECEFF1",
  100: "#CFD8DC",
  200: "#B0BEC5",
  300: "#90A4AE",
  400: "#78909C",
  500: "#5E7A88",
  600: "#546E7A",
  700: "#455A64",
  800: "#37474F",
  900: "#263238",
  A100: "#cfd8dc",
  A200: "#b0bec5",
  A400: "#78909c",
  A700: "#455a64"
}
export const teal = {
  50: "#E0F2F1",
  100: "#A8DBD7",
  200: "#70C4BD",
  // 300: "#38ADA2",
  300: "#008578",
  400: "#009688",
  500: "#008578",
  600: "#007165",
  700: "#005C51",
  800: "#00483D",
  900: "#00332A",
  // A100: "#A7FFEB",
  A100: "#005C51",
  A200: "#64FFDA",
  A400: "#1DE9B6",
  A700: "#00BFA5"
}
export const indigo = {
  50: "#E8EAF6",
  100: "#CBCEEB",
  200: "#AEB2E0",
  300: "#9296D4",
  400: "#757AC9",
  500: "#585EBE",
  600: "#4A50A8",
  700: "#3C4392",
  800: "#2E357C",
  900: "#202766",
  A100: "#8C9EFF",
  A200: "#536DFE",
  A400: "#3D5AFE",
  A700: "#304FFE"
}
export const lightGreen = {
  50: "#F1F8E9",
  100: "#DCEDC8",
  200: "#C5E1A5",
  300: "#AED581",
  400: "#9CCC65",
  500: "#8BC34A",
  600: "#7CB342",
  700: "#689F38",
  800: "#558B2F",
  900: "#33691E",
  A100: "#CCFF90",
  A200: "#B2FF59",
  A400: "#76FF03",
  A700: "#64DD17",
  A800: "#567E21"
}
export const red = {
  50: "#FFEBEE",
  100: "#F4C8CA",
  200: "#E9A5A7",
  300: "#DE8283",
  400: "#D35F60",
  500: "#C83C3C",
  600: "#AF3333",
  700: "#962B2B",
  800: "#7C2222",
  900: "#631919",
  A100: "#FF8A80",
  A200: "#FF5252",
  A400: "#FF1744",
  A700: "#D50000"
}
export const orange = {
  50: "#FFF3E0",
  100: "#FCE1BB",
  200: "#F9CF97",
  300: "#F5BE72",
  400: "#F2AC4E",
  500: "#EF9A29",
  600: "#E68D16",
  700: "#DD7F03",
  800: "#CA7407",
  900: "#B7690B",
  A100: "#FFD180",
  A200: "#FFAB40",
  A400: "#FF9100",
  A700: "#FF6D00",
  A800: "#A25B17"
}
